import { JSX, useEffect, useState } from "react"
import { ColumnConfig, Waffles, wafflesKeyColumnName } from "@app/shared/waffles";
import { TextAlignment, WafflesThemes } from "@app/shared/waffles/exports";
import { Payload, ValueType } from "recharts/types/component/DefaultTooltipContent";
import { GapsByAgeData } from "./interfaces";


type GapByAgeTableProps = {
  payload: Payload<ValueType, string | number>[];
}

interface GapsByAgeTableData {
  gapAge: JSX.Element;
  gapCount: string;
  percentOfTotalGaps: string;
  [wafflesKeyColumnName]: string;
}

const columnConfig: ColumnConfig = {
  "gapAge": {
    alignment: TextAlignment.Left,
    displayText: "Gap Age",
    noSort: true,
    style: {paddingRight: "2em" },
    testId: "gap-by-age-tooltip-table__column-gap-age"
  },
  "gapCount": {
    alignment: TextAlignment.Left,
    displayText: "Gap Count",
    noSort: true,
    style: { paddingRight: "2em" },
    testId: "gap-by-age-tooltip-table__column-gap-count"
  },
  "percentOfTotalGaps": {
    alignment: TextAlignment.Left,
    displayText: "Percent of Total Gaps",
    noSort: true,
    testId: "gap-by-age-tooltip-table__column-percent-of-total-gaps"
  }
};

const GapByAgeTooltipTable = (props: GapByAgeTableProps): JSX.Element => {
  const [tableBody, setTableBody] = useState<GapsByAgeTableData[]>([]);


  useEffect(() => {
    const data: GapsByAgeTableData[] = props.payload.map((payload) => {
      return {
        gapAge: getLineItem(payload.name as string, payload.color),
        gapCount: payload.value.toLocaleString(),
        percentOfTotalGaps: getPercentOfTotalGaps(payload.dataKey as string, payload.payload as GapsByAgeData),
        [wafflesKeyColumnName]: payload.name.toLocaleString(),
      };
    });
    setTableBody(data);
  }, [props.payload]);

  return (
      <div className="qes-dashboard-tile__table county">
      <Waffles<GapsByAgeTableData>
        columns={columnConfig}
        data={tableBody}
        disableStickyHeader={true}
        fullWidth={true}
        keyColumns={["county"]}
        testId="top-counties-by-gap"
        theme={WafflesThemes.Simple}
      />
      </div>
  )
}

const getLineItem = (name: string, fillColor: string) => {
  return (
    <p key={name}>
      <i className="qes-dashboard__color-rect" style={{ backgroundColor: fillColor }} />
      <span>{name}</span>
    </p>
  );
}

const getPercentOfTotalGaps = (dataKey: string, payload: GapsByAgeData) => {
  let percent = "";
  switch (dataKey) {
    case "gapAgeOver90":
      percent = payload.percentOfTotalGapsOver90.toLocaleString() + "%";
      break;
    case "gapAge90":
      percent = payload.percentOfTotalGaps90.toLocaleString() + "%";
      break;
    case "gapAge60":
      percent = payload.percentOfTotalGaps60.toLocaleString() + "%";
      break;
    case "gapAge30":
      percent = payload.percentOfTotalGaps30.toLocaleString() + "%";
      break;
  }
  return percent;
}

export default GapByAgeTooltipTable;